module.exports = __webpack_public_path__ + "static/media/Truck-Icon.0667dc91.svg";